import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as moment from 'moment';
import { AppSettings } from '../models/app.settings';
import { Settings } from '../models';

@Injectable()
export class CustomHttpInterceptor implements HttpInterceptor {
  public settings: Settings;
  constructor(private jwtHelper: JwtHelperService, public appSettings: AppSettings) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headersConfig = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Timezone-Offset': moment().utcOffset().toString(),
      'UI-Language': this.appSettings.settings.language.toUpperCase(),
    };
    const token = this.jwtHelper.tokenGetter();
    if (token) {
      headersConfig['Authorization'] = `Bearer ${token}`;
    }
    const request = req.clone({ setHeaders: headersConfig });

    return next.handle(request);
  }
}
